"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { IntercomConnectionStatus } from "./types";

/**
 * useIntercomStatus
 *
 * Intercom connection status for the current workspace. Gated on workspaceId
 * so the request never fires with an empty one (the backend 400s that).
 */
export function useIntercomStatus(workspaceId: string | undefined) {
  const safeId = workspaceId ?? "";

  const { data, isLoading, isError, refetch } =
    useApiGet<IntercomConnectionStatus>(
      integrationKeys.intercom(safeId),
      `/api/intercom/status?workspaceId=${encodeURIComponent(safeId)}`,
      undefined,
      {
        enabled: !!safeId,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    );

  return {
    connected: data?.connected ?? false,
    userEmail: data?.userEmail,
    isLoading,
    isError,
    refetch,
  };
}
